import { useState } from 'react';
import { useIntl } from 'react-intl';
import { InputSearch, MultipleTagSelector, useQueryFetch } from 'sonata-react-components';
import { getInsertionOrdersChannels } from 'sonata-static-storage/lib/entities/insertionOrder/insertionOrder.service';

import { FormExpandableSection } from '@/components/common/FormExpandableSection';
import { useTargetingContext } from '@/contexts/Targeting/TargetingContext';
import { getAppAndSiteChannelTags } from './helpers/getSectionHeaderTags.helper';

import './appAndSiteChannel.styles.scss';

type State = {
  filteredItems: { label: string; value: string }[];
};

function AppAndSiteChannel() {
  const { formatMessage } = useIntl();
  const { setAppAndSiteChannelProps, targeting, resetSection } = useTargetingContext();

  const { channels } = targeting;

  const [{ filteredItems }, setState] = useState<State>({
    filteredItems: []
  });

  const { data: channelsData } = useQueryFetch(
    'ioSettingsChannels',
    async () => {
      const data = await getInsertionOrdersChannels();
      const items = data?.items.map((item: { _id: string; name: string }) => ({
        label: item.name,
        value: item._id
      }));
      setState(prevState => ({
        ...prevState,
        filteredItems: items
      }));
      return data;
    },
    {
      staleTime: 0
    }
  );

  const handleSearchChange = (value: string) => {
    const items = channelsData?.items.map((item: { _id: string; name: string }) => ({
      label: item.name,
      value: item._id
    }));

    const newItems = items.filter((item: { label: string }) => item.label.toLowerCase().includes(value.toLowerCase()));
    setState(prevState => ({
      ...prevState,
      filteredItems: newItems
    }));
  };

  const handleResetChannels = () => {
    resetSection('appAndSiteChannel');
  };

  const isSectionOpened = channels.length > 0;
  const channelTags = getAppAndSiteChannelTags(channels);

  return (
    <div className="appAndSiteChannel" id="appAndSiteChannelBox">
      <FormExpandableSection
        defaultOpen={isSectionOpened}
        onReset={handleResetChannels}
        preffixId="appAndSiteChannel"
        tags={channelTags}
        title={formatMessage({
          defaultMessage: 'App & Site Channel',
          id: 'targeting.appAndSiteChannel.title'
        })}
        tooltipText={formatMessage({
          defaultMessage: 'Target specific website URLs or app bundles directly to narrow down your ad placements.',
          id: 'targeting.appAndSiteChannel.tooltip'
        })}
      >
        <div className="appAndSiteChannel__content">
          <InputSearch
            className="advanceFilters__inputSearch"
            id={'appAndSiteChannel__inputSearch'}
            lens
            name="appAndSiteChannel__inputSearch"
            onChange={handleSearchChange}
            placeholder={formatMessage({
              defaultMessage: 'Search by name',
              id: 'targeting.appAndSiteChannel.search'
            })}
            tiny
          />
          <div className="appAndSiteChannel__contentTags">
            <MultipleTagSelector
              id={'appAndSiteChannel__multipleTag'}
              items={filteredItems}
              mark
              onChange={setAppAndSiteChannelProps}
              selectedItems={channels}
            />
          </div>
        </div>
      </FormExpandableSection>
    </div>
  );
}

export default AppAndSiteChannel;
